<!-- eslint-disable @angular-eslint/template/no-negated-async -->
<div *ngIf="!(isLoading$ | async)"
     appMenuFocusHandler
     #focusHandler="menuFocusHandler"
     class="genesys-presence-button"
     [ngClass]="{ 'on-queue': isOnQueue$ | async, 'off-queue': !(isOnQueue$ | async) }">
  <button appMenuFocusParent
          class="header-menu-link header-button-box"
          (click)="togglePresence()">
    <div class="icon-container">
      <svg-icon icon="person-filled"></svg-icon>
    </div>
  </button>

  <div class="gc-status-dropdown">
    <app-navbar-scrollable-dropdown>
      <ng-container header-content>
        <span class="list-header-label">{{ ( isHybrid ? 'genesysPresenceButton.cxChats' : 'genesysPresenceButton.dxChats' ) | translate}}</span>
      </ng-container>

      <ng-container list-content>
        <app-navbar-status-dropdown-item *ngFor="let presence of presences$  | async"
                                         #dropdownItem
                                         name="{{'genesysPresenceButton.presences.' + presence.name}}"
                                         appMenuFocusTarget
                                         [focusTarget]="dropdownItem"
                                         [focusHandler]="focusHandler"
                                         [isFocusable]="focusHandler.isFocusable"
                                         [selected]="presence.id === (activePresence$ | async)?.id"
                                         [available]="presence.state === PresenceState.Available"
                                         [away]="presence.state === PresenceState.Away"
                                         (select)="changePresence(presence)">
        </app-navbar-status-dropdown-item>
      </ng-container>
    </app-navbar-scrollable-dropdown>
  </div>
</div>
